// libs:
import Vue from 'vue'
import Router from 'vue-router'

// configs:
import routes from './routes'

export function ROUTER (opts) {
  Vue.use(Router)

  const ROUTER = new Router({
    mode: 'history'
    ,routes: []
    ,base: (location.pathname.match(/\/\w*\//ig) || '') + ''
    ,...opts
  })
  return ROUTER
}

export const router = ROUTER({
  routes
})

export default router
